import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import { getUserData, fetchProviderUserRoles } from '../../data/actions'
import { animationSettings } from '../../config'
import 'url-search-params-polyfill'

class Oidc extends React.Component {
  constructor(props) {
    super(props)
  }

  doAuth = async () => {
    const { onGetUserData, getProviderUserRoles } = this.props
    const online = navigator.onLine
    if (online) {
      onGetUserData()
      getProviderUserRoles()
    }
  }

  render() {
    const { isAuthenticated, children } = this.props
    const _timeout = animationSettings.timeout
    if (!isAuthenticated) {
      this.doAuth()
    }
    return (
      <React.Fragment>
        <CSSTransition
          in={!isAuthenticated}
          timeout={_timeout}
          classNames="loader-container"
          unmountOnExit
        >
          <div className="loader-container">
            <div className="loader">
              <wb-spinner mode="dark"></wb-spinner>
            </div>
          </div>
        </CSSTransition>
        {isAuthenticated && children}
      </React.Fragment>
    )
  }
}

Oidc.propTypes = {
  onGetUserData: PropTypes.func,
  getProviderUserRoles: PropTypes.func,
  isAuthenticated: PropTypes.bool,
}

const mapStateToProps = function (state) {
  const { isEditing, isSaving } = state.tenants
  const { tokens, isAuthenticated, username } = state.sso

  return {
    isEditing,
    isSaving,
    tokens,
    isAuthenticated,
    username,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onGetUserData: () => {
      dispatch(getUserData())
    },
    getProviderUserRoles: () => dispatch(fetchProviderUserRoles()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Oidc)
